import { filterDuplicateData } from 'redux/modules/sections';
export const REPLACE_FIELDS = 'REPLACE_FIELDS';
const ADD_FIELD = 'ADD_FIELD';
const UPDATE_TEMPID_FIELD = 'UPDATE_TEMPID_FIELD';
const ADD_GLOBALSECTION_FIELD = 'ADD_GLOBALSECTION_FIELD';
const UPDATE_FIELD_NAME = 'UPDATE_FIELD_NAME';
const UPDATE_FIELD_REF = 'UPDATE_FIELD_REF';

export default function fields(state = [], action) {
    switch (action.type) {
        case REPLACE_FIELDS:
            return action.payload;
        case ADD_FIELD: {
            const { id, sectionId, name, ref = null, seq = 1 } = action.payload;
            return [...state, { id, sectionId, name, ref, seq }];
        }
        case ADD_GLOBALSECTION_FIELD: {
            const { fields } = action.payload;
            const clearFields = filterDuplicateData(state, fields);
            return [...clearFields, ...fields];
        }
        case UPDATE_TEMPID_FIELD: {
            const { mapSections, mapFields } = action.payload;
            const fieldsReplaceTemp = state.map(field => {
                let newField = field;
                if (mapSections[field.sectionId]) {
                    newField = {
                        ...newField,
                        sectionId: mapSections[field.sectionId]
                    };
                }
                if (mapFields[field.id]) {
                    newField = { ...newField, id: mapFields[field.id] };
                }
                return newField;
            });
            return fieldsReplaceTemp;
        }
        case UPDATE_FIELD_NAME: {
            const { id, name } = action.payload;
            const newState = state.map(field => {
                if (field.id === id) {
                    return { ...field, name };
                }
                return field;
            });

            return newState;
        }
        case UPDATE_FIELD_REF: {
            const { id, ref } = action.payload;
            const newState = state.map(field => {
                if (field.id === id) {
                    return { ...field, ref };
                }
                return field;
            });

            return newState;
        }
        default:
            return state;
    }
}

export function addField(id, sectionId, name, ref) {
    return {
        type: ADD_FIELD,
        payload: {
            id,
            sectionId,
            name,
            ref
        }
    };
}

export function addGlobalSectionFields(fields) {
    return {
        type: ADD_GLOBALSECTION_FIELD,
        payload: { fields }
    };
}

export function updateTempIdField(sections = {}, fields = {}) {
    return {
        type: UPDATE_TEMPID_FIELD,
        payload: {
            mapSections: sections,
            mapFields: fields
        }
    };
}

export function updateFieldName(fieldId, fieldName) {
    return {
        type: UPDATE_FIELD_NAME,
        payload: {
            id: fieldId,
            name: fieldName
        }
    };
}
